import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _delay from 'lodash/delay';
import PropTypes from 'prop-types';
// Models
import mDeviceBatch from 'models/deviceBatch';
// Custom
import { getDeviceBatches } from 'actions';
import { fullListShape } from 'constants/PropTypesShapes';
import { addDeviceBatchesPath, navigateToDeviceBatchesShow } from 'production/navigation';
import { AddTextButton } from 'components/buttons/TextButtons';
import MainListTemplate from 'components/templates/MainListTemplate';
import withLoading from 'hocs/WithLoading';
import withTitle from 'hocs/WithTitle';
import DeviceBatchRow from 'production/assets/deviceBatch/DeviceBatchRow';

class DeviceBatchesList extends React.Component {
  constructor(props) {
    super(props);

    this.handleRowDbleClick = this.handleRowDbleClick.bind(this);
    this.doGetRowComp = this.doGetRowComp.bind(this);
  }

  // Handlers
  handleRowDbleClick(deviceBatch) {
    const { handleStartLoading } = this.props;
    if (deviceBatch) {
      // Display loader and display device batch
      handleStartLoading();
      _delay(() => navigateToDeviceBatchesShow(deviceBatch.id), 500);
    }
  }

  // Private
  doGetRowComp(props) {
    return (
      <DeviceBatchRow {...props} />
    );
  }

  render() {
    const { deviceBatches, handleGetDeviceBatches } = this.props;

    return (
      <MainListTemplate
        title={
          <LocalizedMessage id="title.deviceBatchesList" />
        }
        icon={mDeviceBatch.icon}
        displayRefresh
        actionButtons={[
          <AddTextButton key="add" primary path={addDeviceBatchesPath()} />,
        ]}
        name={mDeviceBatch.name}
        listFeatures={mDeviceBatch.listFeatures}
        withQueryParams={false}
        withActions
        nbActions={1}
        elementsData={{
          loading: deviceBatches.loading,
          elements: deviceBatches.elements,
          handleGetList: handleGetDeviceBatches,
        }}
        withPagination={false}
        withVirtualization={false}
        onRowDbleClick={this.handleRowDbleClick}
        rowComp={this.doGetRowComp}
      />
    );
  }
}

DeviceBatchesList.propTypes = {
  deviceBatches: fullListShape.isRequired,
  handleGetDeviceBatches: PropTypes.func.isRequired,
  handleStartLoading: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  deviceBatches: state.deviceBatch.list,
});

const mapDispatchToProps = (dispatch) => ({
  handleGetDeviceBatches: () => {
    dispatch(getDeviceBatches());
  },
});

module.exports = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withLoading,
  withTitle('pageTitle.deviceBatches'),
)(DeviceBatchesList);



// WEBPACK FOOTER //
// ./routes/app/routes/production/routes/deviceBatches/routes/list/components/DeviceBatchesList.js